import { useQuery } from "react-query";
import { getSchoolSchedule, getStudentSchoolSchedule } from "../services/school/schoolschedule/schoolschedule";
import { PagedRequestType } from "../types/PagedResults";
import { Key_schoolschedules } from "../utils/constants";

export const useGetSchoolSchedulesQuery = (data: PagedRequestType, options:any = null) =>
  useQuery(
    [Key_schoolschedules, JSON.stringify(data)],
    () => getSchoolSchedule(data), 
    options?{...options}:{}
  );

export const useGetStudentSchoolSchedulesQuery = (data: PagedRequestType, options:any = null) =>
  useQuery(
    [Key_schoolschedules, JSON.stringify(data)],
    () => getStudentSchoolSchedule(data), 
    options?{...options}:{}
  );